import { Fragment, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Search from "../components/Search";
import { searchPages } from "../scripts/siteSearch";

function Results() {
    const { searchQuery } = useParams();
    const decodedSearchQuery = useMemo(() => {
        if (!searchQuery) {
            return "";
        }

        try {
            return decodeURIComponent(searchQuery);
        } catch (error) {
            return searchQuery;
        }
    }, [searchQuery]);

    const pages = useMemo(
        () => searchPages(decodedSearchQuery),
        [decodedSearchQuery]
    );

    const fromNav = decodedSearchQuery.trim().length > 0;

    return (
        <>
            {fromNav ? (
                <>
                    <h2>
                        Search Results for '
                        {decodedSearchQuery}'
                    </h2>
                    {pages.length > 0 ? (
                        <>
                            <p>
                                {pages.length} result(s) for{" "}
                                <strong>
                                    "{decodedSearchQuery}"
                                </strong>
                            </p>
                            <div className="search-results">
                                {pages.map((page) => {
                                    return (
                                        <Fragment key={page.key}>
                                            <Link
                                                className="page-link"
                                                to={page.path}
                                            >
                                                {page.title}
                                            </Link>
                                            <p>
                                                {page.excerpt}
                                                <div className="results-link">
                                                    <Link to={page.path}>
                                                        https://spikesrewrittenguide.com
                                                        {page.path}
                                                    </Link>
                                                </div>
                                            </p>
                                        </Fragment>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <p>
                            No search results for{" "}
                            <strong>
                                "{decodedSearchQuery}"
                            </strong>
                        </p>
                    )}
                </>
            ) : (
                <br />
            )}
        </>
    );
}

function SearchResults() {
    return (
        <div className="panel">
            <div className="panel-content">
                <h1>Search Spike's Rewritten Guide</h1>
                <Search />
                <Results />
            </div>
        </div>
    );
}

export default SearchResults;
